import { render, staticRenderFns } from "./StepTeamComposition.vue?vue&type=template&id=71f41c80&scoped=true&"
import script from "./StepTeamComposition.vue?vue&type=script&lang=js&"
export * from "./StepTeamComposition.vue?vue&type=script&lang=js&"
import style0 from "./StepTeamComposition.vue?vue&type=style&index=0&id=71f41c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f41c80",
  null
  
)

export default component.exports